<template>
    <div class="card cancelbid ice-wrap" >
        <div class="card-body">
            <div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                    <i class="fas fa-times-circle"></i>
                </button>
                <h5 class="card-title">Reject Reason</h5>
                <p><b>{{offer.cusipVal}}</b> : {{offer.cusipDescription}}</p>
            </div>
            <hr class="divider">
            <div class="" v-bind:style=" offer ? 'display:block' : 'display: none;'">
                <ul>
                    <li v-if="offer.tmcResText">TMC REJECTED REASON : <span>{{offer.tmcResText ? offer.tmcResText : 'N/A'}}</span></li>
                    <li v-if="offer.tmcRejectedAt">TMC REJECTED AT  : <span>{{offer.tmcRejectedAt ? moment.utc(offer.tmcRejectedAt).tz('America/New_York').format('MM/DD/YYYY h:mm:ss a') : 'N/A'}}</span></li>
                    <hr v-if="offer.twdResText" class="divider">
                    <li v-if="offer.twdResText">TWR REJECTED REASON : <span>{{offer.twdResText ? offer.twdResText : 'N/A'}}</span></li>
                    <li v-if="offer.twdRejectedAt">TWR REJECTED AT : <span>{{offer.twdRejectedAt  ? moment.utc(offer.twdRejectedAt).tz('America/New_York').format('MM/DD/YYYY h:mm:ss a') : 'N/A'}}</span></li>
                    <hr v-if="offer.ibpResText" class="divider">
                    <li v-if="offer.ibpResText">KBP REJECTED REASON  : <span>{{offer.ibpResText ? offer.ibpResText : 'N/A'}}</span></li>
                    <li v-if="offer.ibpRejectedAt">KBP REJECTED AT  : <span>{{offer.ibpRejectedAt ? moment.utc(offer.ibpRejectedAt).tz('America/New_York').format('MM/DD/YYYY h:mm:ss a') : 'N/A'}}</span></li>
                    <hr v-if="offer.mktxResText" class="divider">
                    <li v-if="offer.mktxResText">MKTX REJECTED REASON  : <span>{{offer.mktxResText ? offer.mktxResText : 'N/A'}}</span></li>
                    <li v-if="offer.mktxRejectedAt">MKTX REJECTED AT  : <span>{{offer.mktxRejectedAt ? moment.utc(offer.mktxRejectedAt).tz('America/New_York').format('MM/DD/YYYY h:mm:ss a') : 'N/A'}}</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'offerInfo',
    props: ['offer'],
};
</script>
<style>
.ice-wrap ul li{
    float: none;
    margin-bottom: 0px;
}
.divider{
    margin: 10px 0;
    border-top: 1px solid #fff;
}
</style>